<!-- <div class="toggletarget togglegroup"> -->
<a *ngIf="shouldShowRequestNumberTitle" (click)="onBack()" class="back u-mb40 toggle global-hand" data-id="tab-one-c">
  {{ backButtonText ? backButtonText :  (requirementId ? 'Estado solicitud Nº ' + requirementId.toString() : '') }}
</a>

<div *ngIf="shouldShowPersonalData">
  <div class="col-md-12">
    <h2 class="txt txt--section u-mb30">
      {{personalDataTitle}}
    </h2>
    <app-person-card [personData]="personData" [boxColor]="personCardBoxColor"></app-person-card>
  </div>
  <!-- Divider -->
  <div class="col-md-12">
    <div class="u-bt u-bt--grey u-pt40">
    </div>
  </div>
  <!-- Divider -->
</div>

<!-- Restricciones y licencias municipales reales -->
<div *ngIf="shouldShowLicenseSection" class="col-md-12 u-mb30">
  <h2 class="txt txt--section u-mb30">
    Licencia
  </h2>
  <div class="row p-0">
    <div class="col-md-4 col-lg-4 u-mb20" style="display: flex;">
      <img class="qr-own" [src]="qrImage" alt="">
      <div class="" style="
            width: 100%;
            flex-direction: column;
            display: flex;
            align-items: center;
            flex: 1;
            padding-left: 5px;
        ">
        <h2 class="txt txt--section padding-license-sections-except-qr" style="text-align: center;">
          Minera {{assetId == 1 ? 'Escondida' : 'Spence'}}
        </h2>
        Nº: {{licenseNumber}}
      </div>
    </div>
    <div class="col-md-4 col-lg-4 u-mb20 padding-license-sections-except-qr">
      <h2 class="txt txt--section  subtitle-own">
        Restricciones de conducción
      </h2>
      {{ restrictions ? restrictions : 'No se declaran restricciones.'}}
    </div>
    <div class="col-md-4 col-lg-4 u-mb20 padding-license-sections-except-qr">
      <h2 class="txt txt--section subtitle-own">
        Licencias municipales
      </h2>
      {{realMunicipalLicenses.join(', ')}}
    </div>
  </div>
</div>
<!-- Divider -->
<div *ngIf="shouldShowLicenseSection"  class="col-md-12">
  <div class="u-bt u-bt--grey u-pt40">
  </div>
</div>
<!-- Divider -->

<div class="col-md-12" *ngIf="(equipments.length > 0 && documents.length > 0 && shouldShowFlow)">
  <h2 class="txt txt--section u-mb30">
    Estado de la solicitud
  </h2>
  <div *ngIf="requirementId">
    <app-flow-states (dataLoaded)="flowDataIsLoaded = $event" [id]="requirementId" [centered]="false"></app-flow-states>
  </div>
  <!-- Divider -->
  <div class="col-md-12">
    <div class="u-bt u-bt--grey u-pt40">
    </div>
  </div>
  <!-- Divider -->
</div>

<div *ngIf="(equipments.length > 0 && documents.length > 0)">
  <div class="col-md-12">
    <h2 class="txt txt--section u-mb30" *ngIf="shouldShowEquipmentTitle">
      {{equipmentTitle}}
      {{assetId === 1 ? 'MEL' : ''}}
      {{assetId === 2 ? 'SPC' : ''}}
    </h2>
    <div class="col-md-12">
      <app-equipment-row *ngFor="let item of equipments; let index = index;" [index]="index"
        [equipmentId]="item.equipmentId" [equipmentName]="item.equipmentName" [equipmentBrand]="item.equipmentBrand"
        [equipmentModel]="item.equipmentModel" [licenseTypes]="item.licenseTypes"
        [conductionZones]="item.conductionZones" [expiredAt]="item.expiredAt"
        [municipalLicenses]="item.municipalLicenses" [state]="item.equipmentStatus"
        [note]="item.note"
      >
      </app-equipment-row>
    </div>
  </div>
</div>

<div class="loader-licenses" *ngIf="(equipments.length === 0 && documents.length === 0) && !getDetailsError">
  <app-loader></app-loader>
</div>

<app-mine-requirement-table *ngIf="shouldShowMineDocumentTable" [formArray]="mineDocumentTableForm"
  [requirementId]="requirementId" [documents]="mineDocuments"></app-mine-requirement-table>

<p *ngIf="getDetailsError">Ha ocurrido un error al intentar obtener la información asociada al detalle de solicitud.</p>

<div class="col-md-12">
  <ng-container *ngIf="(equipments.length > 0 && documents.length > 0) && personMdmid && requirementId">
    <app-document-table
      [documents]="documents" [shouldShowDocumentLinks]="shouldShowDocumentLinks"
      [shouldEditEffectiveDate]="shouldEditEffectiveDate" [formArray]="documentTableForm"
      [driverMdmid]="personMdmid"
      [assetId]="assetId"
      [requirementId]="requirementId"
      [driverIsEmployee]="driverIsEmployee"
    >
    </app-document-table>
</ng-container>

</div>
